const FontAwesome = (props) => {
    return <i className={'fa-'+(props.type ? props.type : 'solid')+' fa-'+props.icon}></i>
}

export default FontAwesome;